/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessInstanceDto } from '../../models/process-instance-dto';

export interface AutomatedProcessGetProcessInstanceDetails$Params {
  processInstanceId: string;
}

export function automatedProcessGetProcessInstanceDetails(http: HttpClient, rootUrl: string, params: AutomatedProcessGetProcessInstanceDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessInstanceDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetProcessInstanceDetails.PATH, 'get');
  if (params) {
    rb.path('processInstanceId', params.processInstanceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessInstanceDto>;
    })
  );
}

automatedProcessGetProcessInstanceDetails.PATH = '/automated-process/process-instance/{processInstanceId}';